import type { FC, ReactNode } from 'react'

import { days, sessionsForDay } from '@/constants/metric'
import { SectionHeading } from '@/components/generals/section-heading'
import { SessionRow } from '@/components/generals/session-row'

export const ScheduleSection: FC = (): ReactNode => {
    return (
        <>
            <section id='schedule' aria-labelledby='schedule-title' className='scroll-mt-[96px] px-0 pt-20 tab:px-[60px] tab:pt-28'>
                <div className='fw-container flex flex-col items-center'>
                    <SectionHeading
                        tag='Schedule'
                        title={<span id='schedule-title'>What you can expect</span>}
                        description='Three days, three themes, twelve sessions. Two of them are hands-on workshops with a laptop open and real numbers in the room.'
                    />
                </div>
            </section>

            {days.map((day) => (
                <section
                    key={day.id}
                    id={day.id}
                    aria-label={`${day.label} - ${day.theme}`}
                    className='scroll-mt-[96px] px-0 py-12 tab:px-[60px] tab:py-16'
                >
                    <div className='fw-container grid gap-8 desk:grid-cols-[minmax(0,340px)_minmax(0,1fr)] desk:gap-16'>
                        <div className='desk:sticky desk:top-[104px] desk:self-start'>
                            <div data-reveal='up' className='flex flex-col gap-4 border-t border-line pt-6'>
                                <p className='font-sans text-[14px] font-medium uppercase leading-[1em] tracking-[0.02em] text-ink'>
                                    {day.label}{' '}
                                    <span className='text-ink-mute'>
                                        {day.date}
                                    </span>
                                </p>

                                <h3 className='font-sans text-[26px] font-medium leading-[1.2em] text-ink tab:text-[32px]'>
                                    {day.theme}
                                </h3>

                                <p className='max-w-[420px] font-body text-[16px] leading-[1.4em] text-ink-soft'>
                                    {day.themeCopy}
                                </p>
                            </div>
                        </div>

                        <ul className='flex flex-col gap-3'>
                            {sessionsForDay(day.id).map((session, index) => (
                                <li
                                    key={session.slug}
                                    data-reveal='up'
                                    data-reveal-delay={0.04 * index}
                                >
                                    <SessionRow session={session} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>
            ))}
        </>
    )
}
